<template>
    <div class="position-relative" @click="$refs.input.focus()">
        <div class="z-index-0 position-absolute">
            <input
                ref="input"
                @keyup.up="prevItem"
                @keyup.down="nextItem"
                @keyup.left="prevTab"
                @keyup.right="nextTab"
                @keyup.enter="selectCurrent"
            />
        </div>
        <div class="z-index-1 position-relative d-flex align-items-stretch tab-item" v-if="!state.filter">
            <div
                class="flex-grow-1 py-1 caption text-center text-nowrap cursor-pointer"
                v-for="(tab, index) in tabs"
                :class="{
                    'bg-primary-blue text-primary-white': state.tabSelected === index,
                    'bg-primary-white text-primary-blue': state.tabSelected !== index
                }"
                :key="tab.label"
                @click="setTab(index, -1)"
            >
                {{ tab.label }}
            </div>
        </div>
        <div class="z-index-1 position-relative font-14 tf-scroll-container--50vh w-100" ref="results">
            <template v-for="({ data, level }, index) in displayList">
                <div
                    class="ps-4 py-1 pe-4 caption cursor-pointer"
                    :class="{
                        'bg-primary-blue text-primary-white': state.itemSelected === index,
                        'text-grey-900 bg-primary-white': state.itemSelected !== index
                    }"
                    ref="item"
                    :key="(data.id || data.label || index) + '-' + index"
                    @click="select(data, index)"
                >
                    <div
                        :class="{
                            ['tf-tabs-autocomplete-' + level]: true
                        }"
                        v-html="data.label"
                    ></div>
                </div>
                <div class="mx-2 border-bottom" v-if="index < flatTree.length - 1" :key="(data.id || data.label || index) + '-border-' + index"></div>
            </template>
        </div>
    </div>
</template>

<script>
// bl
import getResults from '@se/bl/tabs-autocomplete/results'

// tabs = [{
// 	label,
// 	tree: [{
// 		label,
// 		...
// 		children,
// 	}],
// }]
export default {
    name: 'TabsAutocomplete',
    props: {
        tabs: Array,
        events: Object,
        // has selected indicator and
        // tracks changes by equality === in the selected prop
        selected: [String, Number, Boolean, Object, Array],
        isSelected: Function
    },
    data() {
        return {
            data: {
                // selected, used for reset on close
                tabSelected: 0,
                itemSelected: 0
            },
            off: [],
            state: {
                // highlighted
                tabSelected: 0,
                itemSelected: 0,
                filter: ''
            }
        }
    },
    computed: {
        tree() {
            if (!this.tabs || this.tabs.length === 0) {
                return []
            }
            return this.tabs[this.state.tabSelected].tree
        },
        flatTree() {
            return this.getFlatTree(this.tree)
        },
        filterResults() {
            return getResults(this.tabs, this.state.filter)
        },
        displayList() {
            return this.state.filter ? this.filterResults : this.flatTree
        }
    },
    methods: {
        getFlatTree(tree, level = 0) {
            return tree.flatMap((item) => {
                const children = item.children ? this.getFlatTree(item.children, level + 1) : []
                return [
                    {
                        data: item,
                        level
                    },
                    ...children
                ]
            })
        },
        prevTab() {
            if (this.state.tabSelected === 0) {
                this.setTab(this.tabs.length - 1)
            } else {
                this.setTab(this.state.tabSelected - 1)
            }
        },
        nextTab() {
            if (this.state.tabSelected === this.tabs.length - 1) {
                this.setTab(0)
            } else {
                this.setTab(this.state.tabSelected + 1)
            }
        },
        prevItem() {
            if (this.state.itemSelected === 0) {
                this.setItem(this.displayList.length - 1)
            } else {
                this.setItem(this.state.itemSelected - 1)
            }
            this.$nextTick(() => {
                this.scrollToSelectedItem()
            })
        },
        nextItem() {
            if (this.state.itemSelected === this.displayList.length - 1) {
                this.setItem(0)
            } else {
                this.setItem(this.state.itemSelected + 1)
            }
            this.$nextTick(() => {
                this.scrollToSelectedItem()
            })
        },
        setTab(index, itemIndex = 0) {
            this.state.tabSelected = index
            this.setItem(itemIndex)
        },
        setItem(index) {
            this.state.itemSelected = index
            this.scrollToSelectedItem()
        },
        resetScroll() {
            if (!this.selected || this.state.filter) {
                this.scrollToTop()
            } else {
                this.scrollToSelectedItem()
            }
        },
        scrollToTop() {
            $(this.$refs.results).scrollTop(0)
        },
        scrollToSelectedItem() {
            if (this.state.itemSelected < 0) {
                return
            }

            const results = $(this.$refs.results)
            const scrollTop = results.scrollTop()
            const resultsHeight = results.height()

            const item = $(this.$refs.item[this.state.itemSelected])
            if (item.length === 0) {
                return
            }

            const relativeTop = item.position().top
            const top = relativeTop + scrollTop
            const itemHeight = item.height()
            const bottomTop = top + itemHeight

            if (top < scrollTop) {
                results.scrollTop(top - itemHeight * 2)
                return
            }
            if (bottomTop > scrollTop + resultsHeight) {
                results.scrollTop(bottomTop - resultsHeight + itemHeight * 2)
            }
        },
        resetSelected() {
            if (this.selected && !this.state.filter) {
                if (this.data.tabSelected === null) {
                    this.updateSelected()
                }
                this.state.tabSelected = this.data.tabSelected
                this.state.itemSelected = this.data.itemSelected
            } else {
                this.state.tabSelected = 0
                this.state.itemSelected = -1
            }
        },
        updateSelected() {
            this.data.tabSelected = null
            this.data.itemSelected = null
            this.tabs.find((tab, index) => {
                const flatTree = this.getFlatTree(tab.tree)
                const isSelected = flatTree.find((item, index) => {
                    const isSelected = this.isSelected(item.data)
                    if (isSelected) {
                        this.data.itemSelected = index
                    }
                    return isSelected
                })
                if (isSelected) {
                    this.data.tabSelected = index
                }
                return isSelected
            })
        },
        select(data, index) {
            this.setItem(index)
            this.$emit('select', data)
        },
        selectCurrent() {
            if (this.displayList.length === 0) {
                return
            }
            const index = this.state.itemSelected
            const item = this.displayList[index]
            this.select(item.data, index)
        },
        setFilter(filter) {
            this.state.filter = filter
        }
    },
    beforeDestroy() {
        this.off.forEach((off) => off())
    },
    mounted() {
        if (this.events) {
            this.off.push(
                this.events.on('left', () => {
                    if (this.state.filter) {
                        return
                    }
                    this.prevTab()
                }).off,
                this.events.on('right', () => {
                    if (this.state.filter) {
                        return
                    }
                    this.nextTab()
                }).off,
                this.events.on('up', () => {
                    this.prevItem()
                }).off,
                this.events.on('down', () => {
                    this.nextItem()
                }).off,
                this.events.on('select', () => {
                    this.selectCurrent()
                }).off,
                this.events.on('reset-scroll', () => {
                    this.resetScroll()
                }).off,
                this.events.on('reset-selected', () => {
                    this.resetSelected()
                }).off,
                this.events.on('filter', (filter) => {
                    this.setFilter(filter)
                }).off
            )
        }
    },
    watch: {
        tabs() {
            this.data.tabSelected = null
            this.data.itemSelected = null
            this.resetSelected()
            this.resetScroll()
        },
        selected() {
            this.data.tabSelected = null
            this.data.itemSelected = null
            this.resetSelected()
            this.resetScroll()
        },
        'state.filter'() {
            this.resetSelected()
            this.resetScroll()
        }
    }
}
</script>

<style scoped>
.tab-item {
    border-bottom: 1px solid white;
}
</style>
